import React from "react";
import { Tooltip } from "../components/Tooltip";
import { clsx } from "clsx";

interface NewToolbarButtonProps {
	onClick: React.MouseEventHandler;
	onEnter?: React.MouseEventHandler;
	onLeave?: React.MouseEventHandler;
	extra?: React.ReactElement;
	tooltipMessage: string | React.ReactElement;
	isSelected?: boolean;
	testId: string;
}

const NewToolbarButton: React.FC<React.PropsWithChildren<NewToolbarButtonProps>> = (props) => {
	let actualSelected = props.isSelected === true;
	return (
		<div className={"relative w-10 h-10"}>
			<Tooltip content={props.tooltipMessage}>
				<button
					data-testid={props.testId}
					onClick={props.onClick}
					onMouseEnter={props.onEnter}
					onMouseLeave={props.onLeave}
					className={clsx(
						"w-10 h-10 rounded flex items-center justify-center relative text-white cursor-pointer hover:bg-content-primary",
						{
							"bg-content-primary/80 hover:bg-content-primary border-content-primary border":
								actualSelected,
						},
					)}
				>
					{props.children}
				</button>
			</Tooltip>
			{props?.extra}
		</div>
	);
};

export { NewToolbarButton };
